import React, { useState, useContext, useEffect, } from "react";
import { Box, Button, TextField, Typography, IconButton, Grid, Select, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { createOrder, modifyOrder, OneClickTrading, } from "../../../api/request/dashboard/dashboard";
import { ThemeContext } from "../../../context/ThemeContext";
import { setOrderResponse } from "../../../store/Slices/symbolSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import AskValue from "../../global/BidAsk/AskValue";
import BidValue from "../../global/BidAsk/BidValue";
import BuyLimit from "./components/BuyLimit";
import SellLimit from './components/SellLimit'
import BuyStop from './components/BuyStop'
import SellStop from './components/SellStop'
import { setAmountForSymbol } from "../../../store/Slices/amountSlice";
import { setEditOrderDetail, setTradeModalOpen } from "../../../store/Slices/globalSymbolSlice";

const TradeModal = ({ closeModal, onClose, showCloseButton = true, symbol = null }) => {
  const { t } = useTranslation()
  // const [stopLoss, setStopLoss] = useState(null);
  // const [takeProfit, setTakeProfit] = useState(null);
  const [amount, setAmount] = useState(100);
  const [comment, setComment] = useState("");
  // const [orderType, setOrderType] = useState("instantExecution");
  const [disablePlaceorder, setDisablePlaceorder] = useState(true)
  const { darkMode } = useContext(ThemeContext)
  const { globalSymbol, globalSymbolID } = useSelector(state => state.globalSymbol)
  const editOrderDetail = useSelector((state) => state.globalSymbol.editOrderDetail);
  const [orderType, setOrderType] = useState(editOrderDetail?.type || "instantExecution");
  const [stopLoss, setStopLoss] = useState(editOrderDetail?.stopLoss || null);
  const [takeProfit, setTakeProfit] = useState(editOrderDetail?.takeProfit || null);
  const selectedSymbol = useSelector((state) => state.symbol.selectedSymbol)
  const { accountId: accountID } = useSelector(state => state.accountSummary);
  // const symbolId = symbol || globalSymbolID || globalSymbol.id || selectedSymbol?.symbolId;
  const [symbolId, setSymbolId] = useState(editOrderDetail?.symbolId || symbol || selectedSymbol?.symbolId || globalSymbolID || globalSymbol?.id);
  const isEditMode = editOrderDetail  
  const dispatch = useDispatch();
  const { symbols } = useSelector(state => state.watchlist)
  const symbolData = symbols[symbolId] || {};
  const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
  const symbolParameterData = allSymbolParams?.[symbolId] || null;
  const [price, setPrice] = useState(null);
  const [volume, setVolume] = useState();

  const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
  const inputVal = useSelector((state) =>
    state?.amount?.[symbolId] ?? symbolParameterData?.minimumAmountPerDeal ?? 0.01
  );

  // const [volume, setVolume] = useState(editOrderDetail?.amount || symbolParameterData?.minimumAmountPerDeal);
  // const [orderType, setOrderType] = useState(editOrderDetail?.orderType || "instantExecution");
  // const [comment, setComment] = useState(editOrderDetail?.comment || "");
  // const [price, setPrice] = useState(editOrderDetail?.price || 0);
  useEffect(() => {
    setSymbolId(editOrderDetail?.symbolId || symbol || selectedSymbol?.symbolId || globalSymbolID || globalSymbol.id);
  }, [editOrderDetail?.symbolId, symbol, selectedSymbol?.symbolId, globalSymbolID, globalSymbol.id])

  useEffect(() => {
    setVolume(inputVal);
  }, [decimalPlaces, symbolId]);

  const increaseAmount = () => {
    const step = symbolParameterData?.minimumAmountPerDeal || 0.1;
    setVolume(prev => {
      const newVal = (parseFloat(prev) + step).toFixed(decimalPlaces);
      if (symbolParameterData?.maximumAmountPerDeal >= newVal) {
        dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(newVal) }));
        return newVal;
      } else {
        return parseFloat(prev).toFixed(decimalPlaces)
      }
    })
  }
  const decreaseAmount = () => {
    const step = symbolParameterData?.minimumAmountPerDeal || 0.1;
    setVolume(prev => {
      const newVal = (parseFloat(prev) - step).toFixed(decimalPlaces);
      if (symbolParameterData?.minimumAmountPerDeal <= newVal) {
        dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(newVal) }));
        return newVal
      } else {
        return parseFloat(prev).toFixed(decimalPlaces)
      }
    })
  }
  const handleChange = (e) => {
    const value = e.target.value
    const desimals = value.split('.')?.[1]
    if (!desimals) {
      dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(value) }));
      setVolume(value);
      return;
    }
    if (desimals.length <= decimalPlaces) {
      dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(value) }));
      setVolume(value)
    }
  }
  const handleBlur = (e) => {
    const value = e.target.value
    if (volume > symbolParameterData?.minimumAmountPerDeal && volume < symbolParameterData?.maximumAmountPerDeal) {
      // const newVal = Math.round(value / symbolParameterData?.minimumAmountPerDeal) * symbolParameterData?.minimumAmountPerDeal
      const newVal = (value / symbolParameterData?.minimumAmountPerDeal) * symbolParameterData?.minimumAmountPerDeal

      dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(newVal?.toFixed(decimalPlaces)) }));
      setVolume(newVal?.toFixed(decimalPlaces))
    } else {
      if (volume < symbolParameterData?.minimumAmountPerDeal) {
        dispatch(setAmountForSymbol({ symbolId, amount: symbolParameterData?.minimumAmountPerDeal }));
        setVolume(symbolParameterData?.minimumAmountPerDeal)
      } else if (volume > symbolParameterData?.maximumAmountPerDeal) {
        dispatch(setAmountForSymbol({ symbolId, amount: symbolParameterData?.maximumAmountPerDeal }));
        setVolume(symbolParameterData?.maximumAmountPerDeal)
      }
    }
  }
  // const formatPrice = (price, digits) => {
  //   return price ? price?.toFixed(digits) : "";
  // };

  const handleBuy = async () => {
    if (!accountID) {
      toast.error("Account ID not available.");
      return;
    }
    if (amount <= 0) {
      toast.error("Invalid amount");
      return;
    }
    try {
      const orderPayload = {
        accountId: Number(accountID),
        symbolId: symbolId,
        amount: volume,
        side: 1,
        comment: comment || "Order Trigger",
      };
      const response = await OneClickTrading(orderPayload);
      if (response?.status === 200) {
        dispatch(setOrderResponse(response.data)); // Dispatch the response to the Redux store
        // toast.success("Order placed successfully!")
        toast.success(` Trade opened: ID #${response.data.id} , ${symbolData.name} at ${response.data.openPrice} Buy, Amount: ${orderPayload.amount}`);

        // dispatch(fetchAllOrders());
        handleClose();
      } else {
        console.error("Order failed:", response);
        toast.error(response)
      }
    } catch (error) {
      console.error("Error placing order:", error);
      const errorMessage = error?.response?.data?.message || error.message || "Failed to place order.";
      toast.error(errorMessage);
    }
  };

  const handleSell = async () => {
    if (!accountID) {
      toast.error("Account ID not available.");
      return;
    }
    if (amount <= 0) {
      toast.error("Invalid amount");
      return;
    }

    const orderPayload = {
      accountId: Number(accountID),
      symbolId: symbolId,
      amount: volume,
      side: -1,
      comment: comment || "Order Trigger",

    };

    try {
      const response = await OneClickTrading(orderPayload);

      if (response?.status === 200) {
        dispatch(setOrderResponse(response.data));

        toast.success(`Trade opened: ID #${response.data.id} , ${symbolData.name} at ${response.data.openPrice} Sell, Amount: ${orderPayload.amount}`);

        console.log("Trade opened successfully:", response);
        handleClose();
      } else {
        toast.error(response)
      }
    } catch (error) {
      console.error("Error placing sell order:", error);
      const errorMessage = error?.response?.data?.message || error.message || "Failed to place order.";
      toast.error(errorMessage);
    }
  };

  const handleClose = () => {
    console.log('close');
dispatch(setEditOrderDetail(null))
    onClose();
  };
  const handleOrderTypeChange = (event) => {
    setOrderType(event.target.value);
    setPrice("");
  };

  const handlePriceChange = (isIncrease) => {
    setPrice((prev) => {
      let currentPrice = parseFloat(prev);
      if (isNaN(currentPrice)) {
        currentPrice = symbolData?.ask ?? 0;
      }
      const step = 1 / Math.pow(10, symbolData?.digits || 2);
      const priceChange = isIncrease ? step : -step;
      const newPrice = Math.max(0, currentPrice + priceChange);

      return newPrice.toFixed(symbolData?.digits)
    });
  };

  const handlePlaceOrder = async () => {
    if (!accountID) {
      toast.error("Account ID not available.");
      return;
    }
    if (amount <= 0) {
      toast.error("Invalid amount");
      return;
    }

    const stopLossMargin = symbolParameterData?.stopOffset;  // Fixed margin for stop loss
    const takeProfitMargin = symbolParameterData?.stopOffset; // Fixed margin for take profit

    // const calculatedStopLoss = symbolData?.high - stopLossMargin; // Sell Stop Loss
    // const calculatedTakeProfit = symbolData?.low + takeProfitMargin; // Sell Take Profit
    try {
      const orderPayload = {
        accountId: Number(accountID),
        symbolId: symbolId,
        amount: volume,
        type: Number(orderType),
        price: price,
        stopLoss: stopLoss,
        takeProfit: takeProfit,
        comment: comment || "No Comment",
      };
      const response = await createOrder(orderPayload);
      if (response?.status === 200) {
        dispatch(setOrderResponse(response.data)); // Dispatch the response to the Redux store
        // toast.success("Order placed successfully!")
        toast.success(`Trade opened: ID #${response.data.id} , ${symbolData.name} at ${response.data.price}, Amount: ${response.data.amount}`);

        handleClose();
      } else {
        console.error("Order failed:", response);
        toast.error(response)
      }
    } catch (error) {
      console.error("Error placing order:", error);
      const errorMessage = error?.response?.data?.message || error.message || "Failed to place order.";
      toast.error(errorMessage);
    }
  };
  const isInstantExecution = orderType === "instantExecution";


  const handleChangeVolume = (value) => {
    const desimals = value.split('.')?.[1]
    if (!desimals) {
      setVolume(value)
      return;
    }
    if (desimals.length <= decimalPlaces) {
      setVolume(value)
    }
  }

  const handleEditOrder = async () => {
    const payload = {
      id: editOrderDetail?.id,
      accountId: editOrderDetail?.accountId,
      price: price,
      amount: volume,
      stopLoss: stopLoss,
      takeProfit: takeProfit,
      comment: comment,
    };

    try {
      const response = await modifyOrder(payload);
      toast.success(`Order updated: ID #${response.data.id}, ${symbolData?.name} at ${response.data.price}, Amount: ${response.data.amount}`);

      dispatch(setTradeModalOpen(false));
      dispatch(setEditOrderDetail(null));

    } catch (error) {
      const errMsg = error?.response?.data?.message || error?.message || "Failed to update order.";
      toast.error(errMsg);
      console.error(error);
    }
  };

  useEffect(() => {
    if (isEditMode && editOrderDetail?.id) {
      setPrice(editOrderDetail?.price ?? 0);
      setVolume(editOrderDetail?.amount ?? symbolParameterData?.minimumAmountPerDeal);
      setStopLoss(editOrderDetail?.stopLoss ?? 0);
      setTakeProfit(editOrderDetail?.takeProfit ?? 0);
      setComment(editOrderDetail?.comment ?? "");
    }
  }, [isEditMode, editOrderDetail]);

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <Grid container spacing={1} sx={{ overflow: 'auto', height: '100%' }}>
        <Grid item xs={12} display={'flex'} justifyContent={'center'}>
          <Box sx={{ width: "100%", bgcolor: darkMode ? "var(--background-color)" : 'var(--white)', fontSize: "0.7rem" }}>
            {/* Modal Header */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1, border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, }} >
              <Typography sx={{ p: showCloseButton ? 0 : 1, pl: 1, fontSize: '0.85rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{symbolData?.name}</Typography>
              {showCloseButton && (<IconButton onClick={handleClose} style={{ borderLeft: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, color: '#3687ed' }} > <CloseIcon sx={{ fontSize: '1.3rem' }} /> </IconButton>)}
            </Box>

            <Box sx={{ display: "flex", p: 1, flexDirection: 'column' }} >
              <Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{t('type')}</Typography>

              <Select value={orderType} onChange={handleOrderTypeChange} sx={{ fontSize: '0.75rem', "&:hover .MuiOutlinedInput-notchedOutline": { border: "none", }, "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none", }, border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }}  >
                <MenuItem value="instantExecution" sx={{ fontSize: '0.75rem' }}>{t('InstantExecution')}</MenuItem>
                <MenuItem value="1" sx={{ fontSize: '0.75rem' }}>{t("BuyLimit")}</MenuItem>
                <MenuItem value="-1" sx={{ fontSize: '0.75rem' }}>{t('SellLimit')}</MenuItem>
                <MenuItem value="2" sx={{ fontSize: '0.75rem' }}>{t('BuyStop')}</MenuItem>
                <MenuItem value="-2" sx={{ fontSize: '0.75rem' }}>{t('SellStop')}</MenuItem>
              </Select>
            </Box>

            <Box sx={{ p: 1, }}>
              <Box sx={{ mb: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                  <Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{t('amount')}-({t('lot')})</Typography>
                  <Typography variant="caption" align="right" sx={{ fontSize: '0.7rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{`${t('min')}: ${symbolParameterData?.minimumAmountPerDeal}, ${t('max')}: ${symbolParameterData?.maximumAmountPerDeal}`}</Typography>

                </Box>

                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, overflow: "hidden" }}>
                  <IconButton onClick={() => decreaseAmount(-symbolParameterData?.minimumAmountPerDeal)}
                    disabled={volume <= symbolParameterData?.minimumAmountPerDeal} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none" }}>
                    <RemoveIcon fontSize="small" sx={{ fontSize: '1rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                  </IconButton>
                  <TextField onBlur={handleBlur} type='number' value={volume} size="small" onChange={(e) => handleChange(e)} inputProps={{
                    min: symbolParameterData?.minimumAmountPerDeal,
                    max: symbolParameterData?.maximumAmountPerDeal,
                    step: symbolParameterData?.minimumAmountPerDeal
                    , style: { textAlign: "center", fontSize: '0.9rem' }
                  }} sx={{ width: 120, textAlign: "center", "& .MuiOutlinedInput-notchedOutline": { border: "none" }, color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                  <IconButton onClick={() => increaseAmount(symbolParameterData?.minimumAmountPerDeal)}
                    disabled={volume >= symbolParameterData?.maximumAmountPerDeal} sx={{ borderLeft: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none" }}>
                    <AddIcon fontSize="small" sx={{ fontSize: '1rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                  </IconButton>
                </Box>
              </Box>
              {orderType == "1" && !isInstantExecution && (<BuyLimit setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} />)}
              {orderType == "-1" && (<SellLimit setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} />)}
              {orderType == "2" && (<BuyStop setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} />)}
              {orderType == "-2" && (<SellStop setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} />)}


              <Box sx={{ mb: 1 }}><Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{t('comment')}</Typography>
                <TextField fullWidth size="small" className="custom-textfield " value={comment} onChange={(e) => setComment(e.target.value)} /> </Box>
              {isInstantExecution ? (
                <Box sx={{ display: "flex", justifyContent: 'space-around', m: 1, fontSize: 15, fontWeight: 500 }}>
                  <BidValue symbolId={symbolData?.id} digits={symbolData.digits} />
                  <AskValue symbolId={symbolData?.id} digits={symbolData.digits} />
                </Box>
              ) : (null)}

              {isInstantExecution ? (
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Button variant="contained" fullWidth sx={{ borderRadius: 0, bgcolor: '#da5244' }} onClick={handleSell} > {t('sell')}</Button>
                  <Button variant="contained" className="bg-primary" fullWidth sx={{ borderRadius: 0 }} onClick={handleBuy} > {t('buy')}</Button>
                </Box>
              ) : (
                <Button variant="contained" fullWidth sx={{ borderRadius: 0 }} onClick={isEditMode ? handleEditOrder : handlePlaceOrder} disabled={disablePlaceorder}> {isEditMode ? t("updateOrder") : t("placeOrder")}</Button>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TradeModal;
